"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var wrapInStatefulComponent_1 = require("./wrapInStatefulComponent");
var addClassDecoratorSupport = function (Comp) {
    var isSFC = !Comp.prototype;
    return !isSFC ? Comp : wrapInStatefulComponent_1.default(Comp);
};
exports.default = addClassDecoratorSupport;
